// extracted by mini-css-extract-plugin
export default {"Anchor":"_Anchor--QhsS1","PopoverContainer":"_PopoverContainer--vLUAz","Popover":"_Popover--E3u_a","scaleIn":"_scaleIn--NyeZ3"};